import { render, staticRenderFns } from "./communityContent.vue?vue&type=template&id=671292ee&scoped=true"
import script from "./communityContent.vue?vue&type=script&lang=js"
export * from "./communityContent.vue?vue&type=script&lang=js"
import style0 from "./communityContent.vue?vue&type=style&index=0&id=671292ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671292ee",
  null
  
)

export default component.exports